<template>
  <a :href="`/news/news=${news.id}`" class="news__item card card_news">
    <div class="card__inner">
      <div class="card__image">
        <img
          v-if="news.images == null"
          :src="require('@/assets/images/15MGKlq2K_DhuqHGMT0M9H.svg')"
          alt
        />
        <img v-else :src="news.images[0]" alt />
      </div>
      <div class="card__content">
        <div class="card__top">
          <div class="card__category">{{ news.category.name }}</div>
          <div class="card__views">
            <span>{{ news.visits }}</span>
            <svg
              width="13"
              height="9"
              viewBox="0 0 13 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.9174 3.89001C12.8013 3.73114 10.0341 0 6.49994 0C2.96579 0 0.198504 3.73114 0.0824944 3.88986C-0.0274981 4.04058 -0.0274981 4.245 0.0824944 4.39572C0.198504 4.55459 2.96579 8.28573 6.49994 8.28573C10.0341 8.28573 12.8013 4.55456 12.9174 4.39584C13.0275 4.24515 13.0275 4.04058 12.9174 3.89001ZM6.49994 7.42859C3.89666 7.42859 1.64194 4.95215 0.974495 4.14257C1.64108 3.33228 3.89107 0.85714 6.49994 0.85714C9.1031 0.85714 11.3577 3.33314 12.0254 4.14316C11.3588 4.95342 9.10881 7.42859 6.49994 7.42859Z"
                fill="#6e6e6e"
              />
              <path
                d="M6.49994 1.57143C5.08208 1.57143 3.9285 2.72501 3.9285 4.14287C3.9285 5.56074 5.08208 6.71432 6.49994 6.71432C7.91781 6.71432 9.07139 5.56074 9.07139 4.14287C9.07139 2.72501 7.91781 1.57143 6.49994 1.57143ZM6.49994 5.85715C5.55465 5.85715 4.78566 5.08814 4.78566 4.14287C4.78566 3.1976 5.55467 2.4286 6.49994 2.4286C7.44521 2.4286 8.21422 3.1976 8.21422 4.14287C8.21422 5.08814 7.44524 5.85715 6.49994 5.85715Z"
                fill="#6e6e6e"
              />
            </svg>
          </div>
          <div class="card__date">
            {{ new Date(news.created_at).toLocaleDateString() }}
          </div>
        </div>
        <div class="card__main">
          <div class="card__title">
            <h3>{{ news.name | toCut(46) }}</h3>
          </div>
          <div class="card__text" ref="text" v-html="news.text"></div>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: "PostNews",
  props: {
    news: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.card.card_news {
  display: flex;
  flex-direction: column;
  color: $prim_c;

  .card {
    &__inner {
      border-radius: 20px;
      overflow: hidden;
    }

    &__image {
      background-color: rgba($aux_bg, 0.1);

      img {
        width: 100%;
        max-height: 300px;
        object-fit: cover;
      }
    }

    &__content {
      padding: 20px 25px 30px;
      background-color: $sec_bg;
    }

    &__top {
      display: flex;
      color: lighten($prim_c, 15%);
    }

    &__category {
      font-weight: $b_fw;
    }

    &__views {
      margin: 0 10px;

      span {
        margin: 0 7.5px 0 0;
      }
    }

    &__date {
      display: flex;
      flex: 1;
      justify-content: flex-end;
      font-style: italic;
    }

    &__title {
      margin: 20px 0 0;
      text-align: center;

      h3 {
        font-size: 24px;
        line-height: 1.2;
      }
    }

    &__text {
      position: relative;
      max-height: 120px;
      margin: 25px 0;
      overflow: hidden;
      color: rgba($prim_c, 0.8);

      &::before {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 20px;
        content: "";
        background: linear-gradient(180deg, rgba(#fff, 0.8), #fff 100%);
        box-shadow: 0 0 10px 10px rgba(#fff, 0.8);
      }
    }
  }
}
</style>
